export default __webpack_public_path__ + "static/media/icon-calendar.30d74934.svg";